import React from "react";
import dayjs from "dayjs";

import ConsumptionRate from "./sections/ConsumptionRate";
import FinancialOverall from "./sections/FinancialOverall";
import { ImpactTracking } from "./sections/ImpactTracking";
import ProgramImpact from "./sections/ProgramImpact";
import ProjectImpact from "./sections/ProjectImpact";
import { ImplementationTracking } from "./sections/ImplementationTracking";
import OrganizationImpact from "./sections/OrganizationImpact";
import Print, { Printed } from "@hpo/client/utilities/print/Print";
import { ArchiveParams, ArchivePayload } from "@hpo/client/models/Archive";

export type ArchiveReportProps = {
  params: ArchiveParams;
  payload: ArchivePayload;
  appUrl: string;
};

export default function ArchiveReport(props: ArchiveReportProps) {
  const { payload } = props;
  return (
    <Printed>
      <Print.WithLogo logo="/logo-cg.png">
        <h1>{payload.title}</h1>
        <p>{`En date du ${dayjs().format("LL")}`}</p>
      </Print.WithLogo>
      <Print.Space size={2} />
      <img
        src="/archive-header.png"
        style={{ height: "5cm", display: "block", margin: "auto" }}
      />
      <Print.Footer appUrl={props.appUrl} />
      {payload.sections.map((section, i) => {
        if (section.type === "financial-overall") {
          return <FinancialOverall key={i} payload={section} />;
        } else if (section.type === "impact-tracking") {
          return <ImpactTracking key={i} payload={section} />;
        } else if (section.type === "consumption-rate") {
          return <ConsumptionRate key={i} payload={section} />;
        } else if (section.type === "program-impact") {
          return <ProgramImpact key={i} payload={section} />;
        } else if (section.type === "project-impact") {
          return <ProjectImpact key={i} payload={section} />;
        } else if (section.type === "organization-impact") {
          return <OrganizationImpact key={i} payload={section} />;
        } else if (section.type === "implementation-tracking") {
          return <ImplementationTracking key={i} payload={section} />;
        } else {
          throw new Error("Unknown section type");
        }
      })}
    </Printed>
  );
}
